import * as React from 'react'
import Img from 'gatsby-image'
import { Container } from '../styles'
import { Flex } from 'grid-styled'
import { Customer, Content, AfterContent } from './styles'

interface IProps {
  image: object
}

export const SocialCases: React.SFC<IProps> = ({ image }) => (
  <Container id="social">
    <Flex mt={5} justifyContent="center">
      <h1>Social Marketing Case Studies</h1>
    </Flex>
    <Customer>
      <Content color="#4099ff">
        <a href="https://smartonhold.com.au">
          <img
            src="https://smartonhold.com.au/wp-content/uploads/2015/11/SOHO-Website-Header-November-2015-Part4-02.png"
            width="254"
            height="46"
            alt="Smart on hold logo"
          />
        </a>
        <p>
          Smart On Hold came to us to help grow their traffic through social
          media. An extra 4000 site visits per month later feeding directly into
          their sales funnel and they're glad they did.
        </p>
      </Content>
      <Img fluid={image} />
    </Customer>
  </Container>
)
